Dates = require 'lib/dates'
Util = require 'lib/util'
WarningBannerView = require 'views/header/warning-banner-view'
moment = require 'moment'
collapsedTemplate = require 'views/templates/header_warning_account_transfer_required_collapsed'
bigTemplate = require 'views/templates/header_warning_account_transfer_required_big'
delayedTemplate = require 'views/templates/header_warning_account_transfer_required_delayed'
missedTemplate = require 'views/templates/header_warning_account_transfer_required_missed'

module.exports = class AccountTransferRequiredBannerView extends WarningBannerView
  BANNER_MESSAGE_NAME = "AccountTransferRequired"

  constructor: ({ enterprise }) ->
    super
    @enterprise = enterprise

  events:
    'click .js-dismiss-account-transfer': 'dismiss'
    'click .js-begin-transfer': 'beginTransfer'

  dismiss: (e) ->
    Util.stop(e)
    @model.dismiss BANNER_MESSAGE_NAME, =>
      @render()

  beginTransfer: (e) ->
    Util.stop(e)
    window.location = "/enterprise/#{ @enterprise.get('name') }/transfer-account"

  _remainingDays: ->
    targetDate = Dates.parse(@enterprise.get('prefs').mandatoryTransferDate)
    Dates.getDaysUntil(targetDate)

  renderCollapsed: ->
    remainingDays = @_remainingDays()
    overdue = remainingDays <= 0
    @$el.html(
      collapsedTemplate(
        remainingDays: remainingDays,
        overdue: overdue
        enterpriseName: @enterprise.get('name')
      )
    )

  renderBig: ->
    @$el.html(
      bigTemplate(
        targetDate: Dates.toDateString(@enterprise.get('prefs').mandatoryTransferDate),
        enterpriseName: @enterprise.get('name'),
        isAdmin: @model.id in (@enterprise.get('idAdmins') ? [])
      )
    )

  renderDelayed: ->
    @$el.html(
      delayedTemplate(
        enterpriseName: @enterprise.get('name')
      )
    )

  renderRemainingDays: ->
    remainingDays = @_remainingDays()
    if 1 < remainingDays <= 5
      @$el.addClass('mod-medium-urgent')
    else if remainingDays <= 1
      @$el.addClass('mod-urgent')

    if @enterprise.get('ssoDateDelayed') && @model.id in @enterprise.get('idAdmins')
      @renderDelayed()
    else if @model.isDismissed(BANNER_MESSAGE_NAME)
      @renderCollapsed()
    else
      @renderBig()

  renderMissedDate: ->
    @$el.addClass('mod-urgent')
    @$el.html(missedTemplate())

  render: ->
    if @enterprise?
      @renderRemainingDays()
    else
      @renderMissedDate()
    @



// WEBPACK FOOTER //
// ./app/scripts/views/header/account-transfer-required-banner-view.coffee